import styled from "styled-components";
import ReactPlayer from "react-player/lazy";

export const Wrapper = styled.div`
	width: 100%;
	height: 100vh;
	position: relative;

	@media screen and (max-width: 720px) {
		margin-bottom: 50px;
		object-fit: fill;
	}
`;

export const LoadHero = styled.img`
	width: 100px;
	object-fit: contain;
	left: 46%;
	top: 50%;
	transform: translate(-50%, 100%);
	position: absolute;
	animation: rotation 5s infinite linear;

	@keyframes rotation {
		from {
			transform: rotate(0deg);
		}
		to {
			transform: rotate(359deg);
		}
	}
`;

export const ReactPlayerKoka = styled(ReactPlayer)`
	video {
		object-fit: cover;
	}
`;

export const Container = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
`;

export const ScrollDown = styled.div`
	height: 50px;
	width: 30px;
	border: 2px solid #f4f4f4;
	position: absolute;
	left: 50%;
	bottom: 30px;
	border-radius: 50px;
	cursor: pointer;
	transform: translate(-50%);

	&::after {
		content: "";
		position: absolute;
		top: 20%;
		left: 50%;
		height: 10px;
		width: 10px;
		transform: translate(-50%, -100%) rotate(45deg);
		border: 2px solid #f4f4f4;
		border-top: transparent;
		border-left: transparent;
		animation: scroll-down 1s ease-in-out infinite;
	}
	&::before {
		top: 30%;
		animation-delay: 0.3s;
		animation: scroll-down 1s ease-in-out infinite;
	}

	@keyframes scroll-down {
		0% {
			/* top:20%; */
			opacity: 0;
		}
		30% {
			opacity: 1;
		}
		60% {
			opacity: 1;
		}
		100% {
			top: 90%;
			opacity: 0;
		}
	}

	@media screen and (max-width: 720px) {
		height: 40px;
		width: 20px;
		bottom: 100px;

		&::after {
			content: "";
			height: 8px;
			width: 8px;
		}
	}
`;
